import { yup } from '../../../shared/utils/yup';
import { IPortalSoftware } from '../../software/types';

const yupSoftware: Partial<Record<keyof IPortalSoftware, yup.BaseSchema>> = {};

export const softwareSchema = yup.object({}).shape(yupSoftware);
